import React from "react";
import connectProps from "fantastic/lib/connectProps";
import { compose } from "redux";
import Block from './Block'

const Organization = (props) => {
  const {organization, contents} = props

  const content = () => {
    return contents.replace(/(\[%company-(.*?)%\])/ig, (match, contents, kind, offset, s) => {
      return organization[kind] || contents
    })
  }

  return <Block {...props} contents={content()}/>
};

export default compose(
  connectProps("organization")
)(Organization);
